var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.noScriptHidden)?_c('div',[_c('noscript',[_c('img',{staticStyle:{"display":"none"},attrs:{"height":"1","width":"1","src":`https://www.facebook.com/tr?id=${_vm.pixelId}&ev=${_vm.event}&noscript=1`}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }